module.exports = __webpack_public_path__ + "img/north_america.7e2984b1.svg";